import axios from 'axios'
import { BaseApi } from './base-api'

export class CartApi {
  private m_instance: any

  public constructor() {
    this.m_instance = axios.create({
      baseURL: 'https://api.photos-presse.com/purchase',// 'https://api.prod.photos-presse.com/purchase',
      //  baseURL: 'https://lv3qnegz06.execute-api.us-east-1.amazonaws.com/api' 
    })
  }

  public updateBaseUrl(baseUrl: string): void {
    console.log('updateBaseUrl')

    this.m_instance.defaults.baseURL = baseUrl
  }

  public updateAuthorization(token: string): void {
    console.log('updateAuthorization')

    this.m_instance.defaults.headers.common['Authorization'] = token
  }

  public async purchase(
    userEmail: string,
    payload: Record<string, Array<Record<string, string | number>>>
  ): Promise<JSON> {
    console.log('puarchasePhotos')

    return this.m_instance.put(`/${userEmail}`, payload)
  }

  public async pullLastCart(user_email: string): Promise<JSON> {
    console.log('pullLastCart')

    return this.m_instance.get(`/${user_email}`)
  }

  public async pull(
    payload: Record<string, number | string | Array<string>>
  ): Promise<JSON> {
    console.log('pull')

    return this.m_instance.post('/admin', payload)
  }
}

export function getCartsAdmin(
  payload: Record<string, number | string | Array<string>>
): Promise<Array<any> | any> {
  return BaseApi.instance.getAxiosInstance().post('/purchase/admin', payload)
}